export const CREATE = {
  REQUEST: 'Subcontractor/Create/Request',
  SUCCESS: 'Subcontractor/Create/Success',
  FAILURE: 'Subcontractor/Create/Failure'
};

export const GET = {
  REQUEST: 'Subcontractor/Get/Request',
  SUCCESS: 'Subcontractor/Get/Success',
  FAILURE: 'Subcontractor/Get/Failure'
};

export const CLEAR = {
  REQUEST: 'Subcontractor/Clear/Request',
  SUCCESS: 'Subcontractor/Clear/Success',
  FAILURE: 'Subcontractor/Clear/Failure'
};

export const EDIT = {
  REQUEST: 'Subcontractor/Edit/Request',
  SUCCESS: 'Subcontractor/Edit/Success',
  FAILURE: 'Subcontractor/Edit/Failure'
};

export const DELETE = {
  REQUEST: 'Subcontractor/Delete/Request',
  SUCCESS: 'Subcontractor/Delete/Success',
  FAILURE: 'Subcontractor/Delete/Failure'
};

export const FORSUBMIT = {
  REQUEST: 'Subcontractor/ForSubmit/Request',
  SUCCESS: 'Subcontractor/ForSubmit/Success',
  FAILURE: 'Subcontractor/ForSubmit/Failure'
};
